export enum Last7DaysMode {
  Agent = 'agent',
  License = 'license',
}
